(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mrsaa-cart-api"] && !Shopify.designMode) return;
  try {
    if (!window.MrsaaCart) {
    const routes = () => window.Theme?.routes || {};

    const refreshCart = async () => {
      const cartItems = document.querySelector('cart-items-component');
      if (cartItems) {
        await customElements.whenDefined('cart-items-component');
        return cartItems.fetchCartData();
      }
      const response = await fetch(`${routes().cart_url || '/cart'}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      return response.json();
    };

    window.MrsaaCart = {
      async add(items, source = document.body) {
        const lines = items.map((item) => ({ id: Number(item.id), quantity: Number(item.quantity) || 1 }));
        const itemCount = lines.reduce((sum, line) => sum + line.quantity, 0);

        let deferred = null;
        let CartLinesUpdateEvent = null;
        try {
          ({ CartLinesUpdateEvent } = await import('@shopify/events'));
          deferred = CartLinesUpdateEvent.createPromise();
          source.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: lines.map((line) => ({ merchandiseId: String(line.id), quantity: line.quantity })),
              promise: deferred.promise,
            })
          );
        } catch (error) {
          console.warn('[MrsaaCart] Cart events unavailable', error);
        }

        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);
        const body = { items: lines };
        if (sectionIds.length) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }

        try {
          const response = await fetch(routes().cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const result = await response.json();
          const didError = Boolean(result.status);
          const cart = await refreshCart();

          deferred?.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, source: 'mrsaa', itemCount, didError, sections: result.sections },
          });

          return {
            ok: !didError,
            message: didError ? result.description || result.message || '' : '',
            cart,
            eventsDispatched: Boolean(deferred),
          };
        } catch (error) {
          deferred?.reject(error);
          throw error;
        }
      },
    };
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mrsaa-hero-styles"] && !Shopify.designMode) return;
  try {
    class MrsaaHero extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      this.heading = this.querySelector('.mrsaa-hero__heading');
      if (this.heading && this.classList.contains('mrsaa-hero--one-line')) {
        this.resizeObserver = new ResizeObserver(() => this.fitHeading());
        this.resizeObserver.observe(this.heading.parentElement);
        document.fonts?.ready.then(() => this.fitHeading());
      }

      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-hero-video-toggle]');
      if (!this.video) return;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;

      this.inView = false;
      this.toggle?.addEventListener('click', this.onToggle, options);
      this.motionQuery.addEventListener('change', this.sync, options);
      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          this.inView = entry.isIntersecting;
          this.sync();
        },
        { rootMargin: '200px 0px' }
      );
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
    }

    fitHeading() {
      const heading = this.heading;
      heading.style.fontSize = '';
      const overflow = heading.scrollWidth - heading.clientWidth;
      if (overflow <= 0) return;
      const size = parseFloat(getComputedStyle(heading).fontSize);
      heading.style.fontSize = `${Math.floor(size * (heading.clientWidth / heading.scrollWidth) * 10) / 10}px`;
    }

    sync = () => {
      if (this.motionQuery.matches || this.userPaused) {
        this.video.pause();
        this.setPaused(true);
      } else if (!this.inView) {
        this.video.pause();
      } else {
        this.loadSources();
        this.video.play().then(() => this.setPaused(false)).catch(() => this.setPaused(true));
      }
    };

    loadSources() {
      const pending = this.video.querySelectorAll('source[data-src]');
      if (!pending.length) return;
      for (const source of pending) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
      this.video.load();
    }

    onToggle = () => {
      if (this.video.paused) {
        this.userPaused = false;
        this.loadSources();
        this.video.play().then(() => this.setPaused(false)).catch(() => this.setPaused(true));
      } else {
        this.userPaused = true;
        this.video.pause();
        this.setPaused(true);
      }
    };

    setPaused(paused) {
      this.toggleAttribute('data-video-paused', paused);
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
    }
  }

  if (!customElements.get('mrsaa-hero')) {
    customElements.define('mrsaa-hero', MrsaaHero);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mrsaa-localization"] && !Shopify.designMode) return;
  try {
    if (!window.mrsaaLocalizationBound) {
    window.mrsaaLocalizationBound = true;

    document.addEventListener('click', (event) => {
      document.querySelectorAll('details[data-mrsaa-loc][open]').forEach((picker) => {
        if (!picker.contains(event.target)) picker.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const picker = event.target.closest?.('details[data-mrsaa-loc][open]');
      if (!picker) return;
      event.stopPropagation();
      picker.removeAttribute('open');
      picker.querySelector('summary')?.focus();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mrsaa-marquee-styles"] && !Shopify.designMode) return;
  try {
    class MrsaaMarquee extends HTMLElement {
    static REFERENCE_WIDTH = 1440;

    connectedCallback() {
      this.viewport = this.querySelector('.mrsaa-marquee__viewport');
      this.group = this.querySelector('[data-marquee-group]');
      this.clone = this.querySelector('[data-marquee-clone]');
      this.pauseButton = this.querySelector('[data-marquee-pause]');
      if (!this.viewport || !this.group || !this.clone) return;

      this.originals = [...this.group.children];
      this.seconds = parseFloat(this.dataset.seconds) || 40;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      this.resizeObserver = new ResizeObserver(() => this.fill());
      this.resizeObserver.observe(this.viewport);

      this.intersectionObserver = new IntersectionObserver(([entry]) => {
        this.toggleAttribute('data-offscreen', !entry.isIntersecting);
      });
      this.intersectionObserver.observe(this);

      this.motionQuery.addEventListener('change', () => this.fill(), options);
      this.pauseButton?.addEventListener('click', this.togglePause, options);
      document.addEventListener('shopify:block:select', this.onBlockSelect, options);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect, options);

      this.fill();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
    }

    fill() {
      this.group.querySelectorAll('[data-marquee-fill]').forEach((node) => node.remove());

      if (!this.motionQuery.matches && this.originals.length) {
        const target = this.viewport.clientWidth;
        let guard = 0;
        while (this.group.scrollWidth < target && guard < 30) {
          this.originals.forEach((node) => {
            const copy = node.cloneNode(true);
            copy.setAttribute('data-marquee-fill', '');
            copy.setAttribute('aria-hidden', 'true');
            copy.setAttribute('inert', '');
            copy.removeAttribute('data-shopify-editor-block');
            this.group.append(copy);
          });
          guard += 1;
        }
      }

      this.clone.replaceChildren(
        ...[...this.group.children].map((node) => {
          const copy = node.cloneNode(true);
          copy.removeAttribute('data-shopify-editor-block');
          return copy;
        })
      );

      const groupWidth = this.group.getBoundingClientRect().width;
      const duration = Math.max((groupWidth / MrsaaMarquee.REFERENCE_WIDTH) * this.seconds, 4);
      this.style.setProperty('--mrsaa-marquee-duration', `${duration.toFixed(2)}s`);
    }

    togglePause = () => {
      const paused = !this.hasAttribute('data-paused');
      this.toggleAttribute('data-paused', paused);
      this.pauseButton.setAttribute('aria-pressed', String(paused));
      this.pauseButton.setAttribute(
        'aria-label',
        paused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause
      );
    };

    onBlockSelect = (event) => {
      if (this.contains(event.target)) this.setAttribute('data-paused', '');
    };

    onBlockDeselect = (event) => {
      if (this.contains(event.target) && this.pauseButton?.getAttribute('aria-pressed') !== 'true') {
        this.removeAttribute('data-paused');
      }
    };
  }

  if (!customElements.get('mrsaa-marquee')) {
    customElements.define('mrsaa-marquee', MrsaaMarquee);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mrsaa-product-card"] && !Shopify.designMode) return;
  try {
    if (!window.mrsaaQuickAddBound) {
    window.mrsaaQuickAddBound = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-mrsaa-quick-add]');
      if (!button || button.getAttribute('aria-busy') === 'true' || !window.MrsaaCart) return;
      event.preventDefault();

      button.setAttribute('aria-busy', 'true');
      try {
        const result = await window.MrsaaCart.add([{ id: button.dataset.mrsaaQuickAdd, quantity: 1 }], button);
        if (!result.eventsDispatched && result.ok) {
          window.location.href = window.Theme?.routes?.cart_url || '/cart';
        }
      } catch (error) {
        console.error('[mrsaa-quick-add]', error);
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mrsaa-quick-add-modal"] && !Shopify.designMode) return;
  try {
    class MrsaaQuickAddModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-qa-body]');
      this.loading = this.querySelector('[data-qa-loading]');
      this.cache = new Map();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      document.addEventListener('click', this.onDocumentClick, options);
      document.addEventListener('pointerover', this.onIntent, { ...options, passive: true });
      document.addEventListener('touchstart', this.onIntent, { ...options, passive: true });
      document.addEventListener('focusin', this.onIntent, options);
      this.dialog.addEventListener('click', this.onDialogClick, options);
      this.dialog.addEventListener('change', this.onChange, options);
      this.dialog.addEventListener('submit', this.onSubmit, options);
      this.dialog.addEventListener('close', this.onClose, options);
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    onDocumentClick = (event) => {
      const trigger = event.target.closest('[data-mrsaa-quick-view]');
      if (!trigger || this.contains(trigger)) return;
      event.preventDefault();
      this.open(trigger.dataset.mrsaaQuickView, trigger);
    };

    onIntent = (event) => {
      const trigger = event.target.closest?.('[data-mrsaa-quick-view]');
      if (trigger && !this.contains(trigger)) this.load(trigger.dataset.mrsaaQuickView);
    };

    load(url) {
      const cached = this.cache.get(url);
      if (cached && Date.now() - cached.time < 120000) return cached.promise;

      const separator = url.includes('?') ? '&' : '?';
      const promise = fetch(`${url}${separator}section_id=mrsaa-quick-add`).then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.text();
      });
      promise.catch(() => this.cache.delete(url));
      this.cache.set(url, { promise, time: Date.now() });
      return promise;
    }

    async open(url, trigger) {
      if (trigger.getAttribute('aria-busy') === 'true') return;
      this.trigger = trigger;
      trigger.setAttribute('aria-busy', 'true');
      const token = (this.openToken = Symbol());
      const checkoutMode = trigger.dataset.quickMode === 'checkout';
      this.dialog.toggleAttribute('data-mode-checkout', checkoutMode);

      this.root = null;
      this.body.replaceChildren(this.preview(trigger));
      this.dialog.setAttribute('aria-busy', 'true');
      if (!this.dialog.open) this.dialog.showModal();

      try {
        const html = await this.load(url);
        if (token !== this.openToken || !this.dialog.open) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const root = doc.querySelector('[data-qa-root]');
        if (!root) throw new Error('Missing quick buy content');

        const firstSlide = root.querySelector('.mrsaa-qa__slide');
        if (firstSlide && trigger.dataset.qaImage) {
          firstSlide.style.backgroundImage = `url("${trigger.dataset.qaImage}")`;
        }
        this.body.replaceChildren(document.adoptNode(root));
        this.root = root;
        const buyButton = root.querySelector('[data-qa-buy-now]');
        if (buyButton) {
          buyButton.textContent = checkoutMode ? buyButton.dataset.labelContinue : buyButton.dataset.labelBuy;
        }
        this.variants = JSON.parse(root.querySelector('[data-qa-variants]')?.textContent || '[]');
        this.update(false);
        this.root.querySelector('[data-qa-gallery]')?.scrollTo(0, 0);
      } catch (error) {
        if (token === this.openToken) window.location.href = url;
      } finally {
        this.dialog.removeAttribute('aria-busy');
        trigger.removeAttribute('aria-busy');
      }
    }

    preview(trigger) {
      const fragment = this.loading.content.cloneNode(true);
      const { qaTitle, qaPrice, qaCompare, qaImage } = trigger.dataset;
      if (qaImage) {
        const image = fragment.querySelector('[data-qa-preview-image]');
        image.src = qaImage;
        image.hidden = false;
      }
      if (qaTitle) {
        const title = fragment.querySelector('[data-qa-preview-title]');
        title.textContent = qaTitle;
        title.hidden = false;
        fragment.querySelectorAll('[data-qa-preview-fallback]').forEach((line) => line.remove());
      }
      if (qaPrice) {
        fragment.querySelector('[data-qa-preview-amount]').textContent = qaPrice;
        fragment.querySelector('[data-qa-preview-price]').hidden = false;
        if (qaCompare) {
          const compare = fragment.querySelector('[data-qa-preview-compare]');
          compare.textContent = qaCompare;
          compare.hidden = false;
        }
      }
      return fragment;
    }

    onDialogClick = (event) => {
      if (event.target === this.dialog || event.target.closest('[data-qa-close]')) {
        this.dialog.close();
        return;
      }
      const step = event.target.closest('[data-qa-step]');
      if (!step || !this.root) return;
      const input = this.root.querySelector('[data-qa-qty]');
      const value = (Number(input.value) || 1) + Number(step.dataset.qaStep);
      input.value = String(Math.max(1, value));
    };

    onChange = (event) => {
      if (!this.root) return;
      if (event.target.matches('.mrsaa-qa__input')) this.update(true);
      if (event.target.matches('[data-qa-qty]')) {
        event.target.value = String(Math.max(1, Math.round(Number(event.target.value) || 1)));
      }
    };

    onClose = () => {
      this.openToken = null;
      const trigger = this.trigger;
      if (!this.added) requestAnimationFrame(() => trigger?.focus());
      this.added = false;
    };

    selectedOptions() {
      return [...this.root.querySelectorAll('.mrsaa-qa__option')].map(
        (fieldset) => fieldset.querySelector('.mrsaa-qa__input:checked')?.value ?? null
      );
    }

    update(scrollToMedia) {
      const selected = this.selectedOptions();
      const variant = selected.length
        ? this.variants.find((v) => v.options.every((value, i) => value === selected[i]))
        : this.variants[0];
      this.variant = variant;

      const idInput = this.root.querySelector('[data-qa-variant]');
      const add = this.root.querySelector('[data-qa-add]');
      const buy = this.root.querySelector('[data-qa-buy-now]');
      const available = Boolean(variant && variant.available);

      if (variant) {
        idInput.value = variant.id;
        this.root.querySelector('[data-qa-price]').textContent = variant.price;
        const compare = this.root.querySelector('[data-qa-compare]');
        compare.hidden = !variant.compare;
        compare.textContent = variant.compare || '';
      }
      add.disabled = !available;
      buy.disabled = !available;
      add.textContent = available ? add.dataset.labelAdd : add.dataset.labelSoldout;

      this.root.querySelectorAll('.mrsaa-qa__option').forEach((fieldset, index) => {
        fieldset.querySelectorAll('.mrsaa-qa__input').forEach((input) => {
          const possible = this.variants.some(
            (v) =>
              v.available &&
              v.options[index] === input.value &&
              v.options.every((value, i) => i === index || selected[i] == null || value === selected[i])
          );
          input.toggleAttribute('data-unavailable', !possible);
        });
      });

      if (scrollToMedia && variant?.media) {
        const gallery = this.root.querySelector('[data-qa-gallery]');
        const slide = gallery.querySelector(`[data-media-id="${variant.media}"]`);
        if (slide) {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          gallery.scrollTo({ top: slide.offsetTop, left: slide.offsetLeft, behavior });
        }
      }
    }

    quantity() {
      return Math.max(1, Number(this.root.querySelector('[data-qa-qty]').value) || 1);
    }

    showError(message) {
      const error = this.root.querySelector('[data-qa-error]');
      error.textContent = message || error.dataset.fallback;
      error.hidden = false;
    }

    onSubmit = async (event) => {
      event.preventDefault();
      const button = event.submitter;
      if (!this.variant || !button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

      this.root.querySelector('[data-qa-error]').hidden = true;
      button.setAttribute('aria-busy', 'true');
      const items = [{ id: this.variant.id, quantity: this.quantity() }];

      try {
        if (button.hasAttribute('data-qa-buy-now')) {
          const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();
          if (result.status) throw new Error(result.description || result.message || '');
          window.location.href = button.value;
          return;
        }

        if (!window.MrsaaCart) throw new Error('');
        const result = await window.MrsaaCart.add(items, button);
        if (!result.ok) throw new Error(result.message);
        this.added = true;
        this.dialog.close();
        if (!result.eventsDispatched) window.location.href = window.Theme?.routes?.cart_url || '/cart';
      } catch (error) {
        this.showError(error.message);
      } finally {
        button.removeAttribute('aria-busy');
      }
    };
  }

  if (!customElements.get('mrsaa-quick-add-modal')) {
    customElements.define('mrsaa-quick-add-modal', MrsaaQuickAddModal);
  }
  } catch(e) { console.error(e); }
})();

})();
